/**
 * Rota /funis/expirados.
 *
 * Mesma casca do carrinho (`PaginaDoFunil`), com o vocabulario e a regua de
 * assinaturas vencidas (D+15, D+30, D+60, D+90). Empresas sem o funil ligado
 * veem o estado "Nao ativado" em vez de zeros.
 */

import { PaginaDoFunil } from '../components/PaginaDoFunil';

export function FunilExpirados(): JSX.Element {
  return <PaginaDoFunil kind="expirados" />;
}
